import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import { colors } from 'src/theme/colors'

interface ShippingInfoProps {
  title: string
  info: string | number
}

const ShippingInfo: React.FC<ShippingInfoProps> = ({ title, info }) => {
  return (
    <Box mb={4}>
      <Text fontSize='xl' fontWeight='bold' color={colors.primary} mb={3}>
        {title}
      </Text>
      <Text fontSize='lg'>{info}</Text>
    </Box>
  )
}

export default ShippingInfo
